import { cn } from '~/lib/utils';

/** An ordered list of instruction steps with the app's numbering and spacing. */
export function NumberedSteps({ className, ...props }: React.ComponentProps<'ol'>) {
  return <ol className={cn('list-decimal pl-4 [&>li]:mb-3', className)} {...props} />;
}
